import React from "react";
import { TitleActionsProps } from "./Title.types";
import { Actions as StyledActions } from "./Actions.styles";

/**
 * Set of page-wide actions. They'll be displayed on the right hand side of the
 * screen on desktops or below the Title on mobile pages.
 */
export const Actions = ({
  children,
  className,
  breakpoint
}: TitleActionsProps) => (
  <StyledActions className={className} breakpoint={breakpoint}>
    {children}
  </StyledActions>
);
